import axios from 'axios';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Constants from '../../../../utils/Constants';
import UIkit from "uikit";


const EditModal = ({ customerDetails , id, customerData, setCustomerData ,refetch }) => {
const [loader, setLoader] = useState(false);
 
const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm();

const Update = (data) => {

    setLoader(true)

    

      axios({
      method : 'patch',
      headers: {
        Authorization : `Bearer ${localStorage.getItem('token')}`
      },
      data : {
        fullname : data.fullname,
        fatherName: data.fathername,
        gender: data.gender,
        type : data.type,
        dob: data.dob,
        email: data.email,
        ntn: data.ntn,
        organizationName : data.organizationName,
        phone: data.phone,
        secondaryPhone:data.secondaryPhone,
        address: {
              address: data.address,    
              city: data.city,          
              state: data.state
        },
        cnic: data.cnic
      } ,   
      url : Constants.url + `orders/update/${id}`
    }).then((res) => {
        
      setLoader(false)



      if(res.data.status === 'success' ){

        setCustomerData({
            ...customerData,
            fullname:data.fullname,
            // firstName: data.firstName,
            // lastName: data.lastName,
            fatherName: data.fathername,
            organizationName : data.organizationName,
            type : data.type,
            gender: data.gender,
            dob: data.dob,
            ntn: data.ntn,
            email: data.email,
            phone: data.phone,
            secondaryPhone:data.secondaryPhone,
            address: {
              ...customerData.address,  
              address: data.address,    
              city: data.city,          
              state: data.state         // Set the new state
          },
            cnic: data.cnic
        });

        UIkit.modal("#details").hide()

        window.swal({
          icon:'success',
          title:'Updated successfully' 
        }).then(() => UIkit.modal("#details").hide())


        refetch()
      }
      
    }).catch((err) => { 
        console.log(err)
    })

  };

  return (
    <form className="uk-form-stacked uk-padding" onSubmit={handleSubmit(Update)}>

    <div className='uk-grid' uk-grid = '' >
      
      <div className='uk-width-1-2'>
      <div className="uk-margin">
        <label className="uk-form-label uk-heading-small" htmlFor="firstName">
          Full Name
        </label>
        <div className="uk-form-controls">
          <input
            className="uk-input uk-form-medium"
            defaultValue = {customerDetails.fullname}
            id="fullname"
            type="text"
            {...register('fullname')}
            placeholder="Full Name"
          />
        </div>
      </div>

      <div className="uk-margin">
        <label className="uk-form-label uk-heading-small" htmlFor="firstName">
          Father/Husband Name
        </label>
        <div className="uk-form-controls">
          <input
            className="uk-input uk-form-medium"
            defaultValue = {customerDetails.fatherName}
            id="fathername"
            type="text"
            {...register('fathername')}
            placeholder="Father/Husband Name"
          />
        </div>
      </div>



      <div className="uk-margin">
        <label className="uk-form-label uk-heading-small" htmlFor="firstName">
          Gender 
        </label>
        <div className="uk-form-controls">
          <input
            className="uk-input uk-form-medium"
            defaultValue = {customerDetails.gender}
            id="gender"
            type="text"
            {...register('gender')}
            placeholder="gender"
          />
        </div>
      </div>





    {customerDetails.type === 'corporate' ? 
    
      <div className="uk-margin">
        <label className="uk-form-label uk-heading-small" htmlFor="firstName">
          Organization Name 
        </label>
        <div className="uk-form-controls">
          <input
            className="uk-input uk-form-medium"
            defaultValue = {customerDetails.organizationName}
            id="organization"
            type="text"
            {...register('organizationName')}
            placeholder="organization"
          />
        </div>
      </div>
  
  
  :''}

    {customerDetails.type === 'corporate' ? 
    
      <div className="uk-margin">
        <label className="uk-form-label uk-heading-small" htmlFor="firstName">
          Ntn
        </label>
        <div className="uk-form-controls">
          <input
            className="uk-input uk-form-medium"
            defaultValue = {customerDetails.ntn}
            id="ntn"
            type="text"
            {...register('ntn')}
            placeholder="NTN"
          />
        </div>
      </div>
  
  
  :''}






      <div className="uk-margin">
        <label className="uk-form-label uk-heading-small" htmlFor="type">
          Type 
        </label>


              <select

                defaultValue={customerData.type}

                {...register("type", { required: "Field is required" })}
              >


                {/* <option value="">Select Status</option>{" "} */}
                {/* Add a default option */}
                <option value="individual">Individual</option>
                <option value="corporate">Corporate</option>



              </select>
      </div>


      <div className="uk-margin">
        <label className="uk-form-label uk-heading-small" htmlFor="firstName">
          Date of Birth 
        </label>
        <div className="uk-form-controls">
          <input
            className="uk-input uk-form-medium"
            defaultValue = {customerDetails.dob}
            id="dob"
            type="date"
            {...register('dob')}
            placeholder="Date of Birth"
          />
        </div>
      </div>

      <div className="uk-margin">
        <label className="uk-form-label uk-heading-small" htmlFor="email">
          Email
        </label>
        <div className="uk-form-controls">
          <input
            className="uk-input uk-form-medium"
            defaultValue = {customerDetails.email}
            id="email"
            type="email"
            {...register('email')}
            placeholder="Email"
          />
        </div>
      </div>

      </div>




      <div className='uk-width-1-2'>

      <div className="uk-margin">
        <label className="uk-form-label uk-heading-small" htmlFor="phone">
          Phone
        </label>
        <div className="uk-form-controls">
          <input
            className="uk-input uk-form-medium"
            defaultValue = {customerDetails.phone}
            id="phone"
            type="text"
            {...register('phone')}
            placeholder="Phone"
          />
        </div>
      </div>

      <div className="uk-margin">
        <label className="uk-form-label uk-heading-small" htmlFor="phone">
          Secondary Phone
        </label>
        <div className="uk-form-controls">
          <input
            className="uk-input uk-form-medium"
            defaultValue = {customerDetails.secondaryPhone}
            id="secondaryPhone"
            type="text"
            {...register('secondaryPhone')}
            placeholder="Secondary Phone"
          />
        </div>
      </div>

      <div className="uk-margin">
        <label className="uk-form-label uk-heading-small" htmlFor="city">
          City
        </label>
        <div className="uk-form-controls">
          <input
            className="uk-input uk-form-medium"
            defaultValue = {customerDetails.address ? customerDetails.address.city ||'-': '-' }
            id="city"
            type="text"
            {...register('city')}
            placeholder="City"
          />
        </div>
      </div>

      <div className="uk-margin">
        <label className="uk-form-label uk-heading-small" htmlFor="city">
          State
        </label>
        <div className="uk-form-controls">
          <input
            className="uk-input uk-form-medium"
            defaultValue = {customerDetails.address? customerDetails.address.state || '-' : '-'}
            id="state"
            type="text"
            {...register('state')}
            placeholder="State"
          />
        </div>
      </div>


      <div className="uk-margin">
        <label className="uk-form-label uk-heading-small" htmlFor="address">
          Address
        </label>
        <div className="uk-form-controls">
          <input
            className="uk-input uk-form-medium"
            defaultValue = {customerDetails.address ? customerDetails.address.address || '-' : '-'}
            id="address"
            type="text"
            {...register('address')}
            placeholder="Address"
          />
        </div>
      </div>

      <div className="uk-margin">
        <label className="uk-form-label uk-heading-small" htmlFor="cnic">
          CNIC
        </label>
        <div className="uk-form-controls">
          <input
            className="uk-input uk-form-medium"
            defaultValue = {customerDetails.cnic}
            id="cnic"
            type="text"
            {...register('cnic')}
            placeholder="CNIC"
          />
        </div>
      </div>

      </div>
      
       </div>

      



      





      <div className="uk-margin uk-flex uk-flex-center">
        <button className="uk-button uk-button-secondary uk-button-medium uk-width-1-1" type="submit">
                {loader ? (
                            <div uk-spinner="" className="loader"></div>
                          ) : (
                            "Update"
                          )}
        </button>
      </div>
    </form>
  );
};

export default EditModal;
